import { Flex } from "@chakra-ui/react";
import hj from "@hotjar/browser";
import { type Account, type ChainFullId } from "@umami/chains";
import { useIsSaplingEnabled } from "@umami/state";
import { useEffect } from "react";

import {
  NETWORK_SELECTOR_ITEM_HEIGHT,
  NETWORK_SELECTOR_ITEM_MARGIN_BOTTOM,
} from "./NetworkSelectorItem";
import { NetworkSelectorList } from "./NetworkSelectorList";
import { NetworkSelectorSearchBar } from "./NetworkSelectorSearchBar";
import { useNetworkSelector } from "./useNetworkSelector";

type NetworkSelectorProps = {
  account?: Account;
  onClick: (chainId: ChainFullId) => void;
  isLedger?: boolean;
};

const NETWORK_SELECTOR_ITEM_TOTAL_HEIGHT =
  NETWORK_SELECTOR_ITEM_HEIGHT + NETWORK_SELECTOR_ITEM_MARGIN_BOTTOM;

export const NetworkSelector = ({
  onClick,
  account = {} as Account,
  isLedger = false,
}: NetworkSelectorProps) => {
  const { setInput, filteredChains } = useNetworkSelector(account);

  useEffect(() => {
    hj.stateChange("network_selector");
  }, []);
  const isSaplingEnabled = useIsSaplingEnabled()();

  const selectorListHeight =
    (filteredChains.length + (isSaplingEnabled && !isLedger ? 1 : 0)) *
    NETWORK_SELECTOR_ITEM_TOTAL_HEIGHT;

  return (
    <Flex flexDirection="column" gap="20px" width="100%">
      <NetworkSelectorSearchBar onChange={setInput} />
      <NetworkSelectorList
        height={`${selectorListHeight}px`}
        maxHeight="calc(100vh - 300px)"
        chains={filteredChains}
        isLedger={isLedger}
        onSelectChain={onClick}
      />
    </Flex>
  );
};
